import React from 'react'
import { Route } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router-dom'
import MaskedInput from 'react-text-mask'
import moment from 'moment'

import config from '../../config'
import { getRuntimeFeatures, refreshRuntimeFeatures } from '../../utils/features-runtime'
import { openUpgradeModal } from '../../components/common/UpgradeModal'

// Ant Design imports
import {
  Layout,
  Menu,
  Button,
  Select,
  Modal,
  Popover,
  Divider,
  Badge,
  Checkbox,
  Switch,
  Tag,
  Typography,
  Space,
  Tooltip,
  Avatar,
} from 'antd'
import {
  MenuOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CloseOutlined,
  DownOutlined,
  MessageOutlined,
  UserOutlined,
  TeamOutlined,
  SettingOutlined,
  BuildOutlined,
  SwapOutlined,
  FileTextOutlined,
  BugOutlined,
  UsergroupAddOutlined,

  CommentOutlined,
  CalendarOutlined,
  DashboardOutlined,
  BellOutlined,
  PhoneOutlined,
  FileSearchOutlined,
  QuestionCircleOutlined,
  ClockCircleOutlined,
  MailOutlined,
  UnorderedListOutlined,
  FormatPainterOutlined,
  ThunderboltOutlined,
  QrcodeOutlined,
  WifiOutlined,
  FlagOutlined,
  SoundOutlined,
  LogoutOutlined,
  AppstoreOutlined,
  LockOutlined,
} from '@ant-design/icons'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faBolt } from '@fortawesome/free-solid-svg-icons'

import theme from '../../theme'
import session from '../../utils/session'
import arrayLoop from '../../utils/loop'
import formatUtil from '../../utils/format'
import resources from '../../reducers/inbox/resources'
import { getSequenceTemplates } from '../../components/inbox-v2/resources'
import { getAssignedBots } from '../../reducers/bots/resources'
import { getModuleGroups, getDefaultCalendarModuleGroups, getModuleGroupsByCompany } from '../../reducers/modules/resources'
import { sendLimitReached } from '../../reducers/inbox/actions'
import {
  setSelectedCompany,
  setSelectedCompanyData,
  setSelectedSubCompany,
  resetCompany
} from '../../reducers/company/actions'
import {
  startTour,
} from '../../reducers/tour/actions'
import { getDashboardSteps } from '../../components/guide/toursteps'
import guideRes from '../../reducers/tour/resources'
import { checkUserGroupDefault } from '../../reducers/apps/resources'
import { getAllCompanies } from '../../reducers/company/resources'

import {
  getUserNotifications,
  readNotifications,
} from '../../reducers/notification/resources'
import { setNotification } from '../../reducers/notification/actions'

import { leaveRoom, initRoom } from '../../io'
import 'intro.js/introjs.css'
import { Steps } from 'intro.js-react'

import _ from 'lodash'
import mixpanel from '../../utils/mixpanel'
import NewMessageModal from '../../components/new-message/NewMessageModal'
import NotificationListAntd from '../../components/common/NotificationListAntd'
import MinimapScroll from '../../components/common/MinimapScroll'
import transformSchedMsg from '../../utils/schedmsg'

import {
  getUserSettings, setUserSettings
} from '../../reducers/integrations/resources'

import UserAvatar from '../../components/common/UserAvatar'
import { ThemeContext } from '../../ThemeContext'

import './index.css'

import { setUserAppSettingsState } from '../../reducers/integrations/actions'
import { setUserSettingState } from '../../reducers/user/actions'
import { getUserById } from '../../reducers/user/resources'
import CryptoJS from 'crypto-js'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

library.add(faBullhorn)
library.add(faBolt)

const { Header, Sider, Content } = Layout
const { Text } = Typography

// Menu route paths for sidebar highlighting (more specific routes first)
const MENU_ROUTES = [
  '/settings/calendar',
  '/settings/availability',
  '/settings',
  '/interview-invites',
  '/integrations/v2',
  '/dashboard',
  '/ai-assistants',
  '/inbox',
  '/message-audit',
  '/contacts',
  '/reporting',
  '/build-bot',
  '/vonage-numbers',

  '/templates',
  '/companies',
  '/access-control',
  '/testbot',
  '/campaign',
  '/groups',
  '/module-group',
  '/apply-by-text',
  '/client-users',
  '/queues',
  '/email-log',
  '/sessions'
]

const getSelectedMenuIndex = (pathname) => {
  for (const item of MENU_ROUTES) {
    if (pathname.indexOf(item) !== -1) {
      return item
    }
  }
  return '/dashboard'
}

const getOpenKeys = (pathname) => {
  if (pathname.includes('/contacts') || pathname.includes('/groups')) return ['/contacts']
  const adminRoutes = [
    '/message-audit', '/reporting', '/build-bot', '/vonage-numbers',
 '/companies', '/access-control', '/module-group'
  ]
  if (adminRoutes.some(route => pathname.includes(route))) return ['/message-audit']
  const healthRoutes = ['/queues', '/email-log', '/sessions']
  if (healthRoutes.some(route => pathname.includes(route))) return ['/queues']
  return []
}

// Define layout
class LayoutComponent extends React.Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props)
    this.scrollContainerRef = React.createRef()

    // Determine the selected menu item based on current URL path
    const initialSelectedIndex = getSelectedMenuIndex(props.location.pathname)
    const initialOpenKeys = getOpenKeys(props.location.pathname)

    this.state = {
      showUserMenu: false,
      open: true,
      selectedIndex: initialSelectedIndex,
      openKeys: initialOpenKeys,
      openMessageModal: false,
      showSnackBar: false,
      snackBarMessage: '',
      tmpls: [],
      seqTmpls: [],
      defaultLongNum: '',
      defaultABT: '',
      openLimitReachedDialog: false,
      moduleGroups: [],
      calendarModuleGroups: null,
      moduleGroup: '',
      showNoCalendarDialog: false,
      contact: null,
      companyList: [],
      QRDialogVisible: false,
      qrImage: '',
      tour: false,
      openAbtMenu: false,
      unreadCount: 0,
      showNotificationMenu: false,
      notificationList: [],
      isChecked: true,
      isAdmin: false,
      isCompanyAdmin: false,
      acknowledgmentEnabled: false,
      subProfiles: [],
      selectedSubCompany: {},

      openOptions: false,
      openModal: false,
      openModGroupsDialog: false,
      userAvatar: (session.get('userData') || {}).avatar_url || '',
    }

    this.notificationCount = 10

    if (session.get('token')) {
      getAssignedBots().then((bots) => {
        if (bots && bots.data) {
          let defaultLongNum = ''
          bots.data.map((bot) => {
            if (bot.default === 'longcode') {
              defaultLongNum = bot.mobile
            }
          })
          this.setState({ defaultLongNum })
        }
      })
      ;(async () => {
        const {
          role: userRole,
          default_abt: defaultABT,
          parent_bot_abt: parentBotABT,
          allProfiles,
          keyword
        } = session.get('userData')

        const isAdmin = (userRole || '') === config.userRoles.ghAdmin
        const isCompanyAdmin = (userRole || '') === config.userRoles.companyAdmin
        const isParentCompanyUsing = (allProfiles && (allProfiles.length > 1))

        let qrImage = session.get('userData').qr_image
        qrImage =
          qrImage && qrImage.length > 0
            ? `${config.api.host}/api/v1/files/bot/qr/${qrImage}`
            : ''

        let moduleGroups = await getModuleGroups()
        let notificationList = await getUserNotifications(
          `pageSize=${this.notificationCount}`,
        )
        this.props.setNotification(notificationList)
        let calendarModuleGroups = await getDefaultCalendarModuleGroups()
        calendarModuleGroups = calendarModuleGroups.data

        moduleGroups = moduleGroups.data

        if (isParentCompanyUsing) {
          this.setState({ subProfiles: allProfiles })
          const selectedSubCompany = session.get('selectedSubCompany')

          this.props.setSelectedSubCompany({
            selectedSubCompany:
              selectedSubCompany || allProfiles[0]
          })
        }

        if (isAdmin) {
          let companies = await getAllCompanies()
          this.setState({ companyList: companies.data })
        }

        this.setState({
          isCompanyAdmin,
          isAdmin,
          moduleGroups,
          calendarModuleGroups,
          defaultABT: parentBotABT || defaultABT,
          qrImage,
          keyword: keyword || 'Jobs'
        })
      })()

      resources.getTemplates().then((res) => {
        if (res.data) {
          this.setState({
            tmpls: res.data,
          })
        }
      })
    }
  }

  componentDidMount() {
    window.addEventListener('avatarUpdated', this.handleAvatarUpdate);
    window.addEventListener('profileUpdated', this.handleProfileUpdate);
    window.addEventListener('officeHoursUpdated', this.handleOfficeHoursUpdate);
    window.addEventListener('gh:companies-changed', this.handleCompaniesChanged);

    // Auto-trigger guided tour on first login
    const userData = session.get('userData')
    if (userData?.id) {
      this.refreshUserSessionFromApi(userData.id)

      // Re-read effective features on boot so an admin's grant/revoke applies
      // without a logout/login — the login payload's copy can be stale. Bump a
      // counter when they actually changed so the sidebar + routes re-evaluate.
      const before = JSON.stringify(userData.features || null)
      refreshRuntimeFeatures().then((features) => {
        if (features && JSON.stringify(features) !== before) {
          this.setState((s) => ({ featuresVersion: (s.featuresVersion || 0) + 1 }))
        }
      })

      guideRes.getGettingStartedGuideMeta(userData.id).then((res) => {
        const completed = res.data
          ? JSON.parse(res.data.settings)?.completed || []
          : []
        if (!completed.includes('dashboard-tour')) {
          this.setState({ dashboardTourPending: true })
          if (this.props.location.pathname === '/dashboard') {
            setTimeout(() => this.launchDashboardTour(), 800)
          }
        }
      }).catch(() => {
        // If API fails, don't block the app — just skip auto-trigger
      })
    }
  }

  // Reconcile session.userData with the server on mount so the topbar
  // (avatar, name, etc.) recovers from any prior staleness — e.g. an
  // avatar change made in another tab, or session left over from a brand swap.
  refreshUserSessionFromApi = (userId) => {
    getUserById(userId).then((res) => {
      const fresh = res?.data
      if (!fresh) return
      const current = session.get('userData') || {}
      const reconciled = {
        ...current,
        name: fresh.name ?? current.name,
        nickname: fresh.nickname ?? current.nickname,
        email: fresh.email ?? current.email,
        mobile: fresh.mobile ?? current.mobile,
        job_title: fresh.job_title ?? current.job_title,
        avatar_url: fresh.avatar_url ?? current.avatar_url,
        avatar_type: fresh.avatar_type ?? current.avatar_type,
        language: fresh.language ?? current.language, // ADR-035: viewer language for translations
      }
      session.set('userData', reconciled)

      if (reconciled.avatar_url !== current.avatar_url) {
        window.dispatchEvent(new CustomEvent('avatarUpdated', { detail: reconciled.avatar_url }))
      }
      if (reconciled.name !== current.name) {
        window.dispatchEvent(new CustomEvent('profileUpdated', { detail: reconciled }))
      }
    }).catch(() => {
      // Non-blocking — topbar will just keep using the cached session values
    })
  }

  componentWillUnmount() {
    window.removeEventListener('avatarUpdated', this.handleAvatarUpdate);
    window.removeEventListener('profileUpdated', this.handleProfileUpdate);
    window.removeEventListener('officeHoursUpdated', this.handleOfficeHoursUpdate);
    window.removeEventListener('gh:companies-changed', this.handleCompaniesChanged);
  }

  handleCompaniesChanged = () => {
    getAllCompanies(this.state.isChecked).then((response) => {
      this.setState({ companyList: response.data || [] });
    });
  }

  handleAvatarUpdate = (event) => {
    let url = event.detail;
    if (!url) {
        url = (session.get('userData') || {}).avatar_url;
    }
    this.setState({ userAvatar: url });
  }

  handleProfileUpdate = () => {
    this.forceUpdate();
  }

  handleAvatarRefresh = (newUrl) => {
      // Update state
      this.setState({ userAvatar: newUrl });
      
      // Update session storage
      const userData = session.get('userData');
      if (userData) {
          userData.avatar_url = newUrl;
          session.set('userData', userData);
      }
  }

  handleOfficeHoursUpdate = (event) => {
    const { acknowledgmentEnabled } = event.detail
    this.setState({ acknowledgmentEnabled })
  }

  componentWillReceiveProps(nextProps) {
    const {
      limitReached,
      contact,
      tourSteps,
      userSettings
    } = nextProps
    ;(async () => {
      let settings = await getUserSettings()
      settings = settings.data

      if (settings) {
        const { acknowledgmentEnabled } = settings

        this.setState({
          acknowledgmentEnabled: acknowledgmentEnabled || this.state.acknowledgmentEnabled
        })

        if (nextProps.userSettings.acknowledgmentEnabled !== acknowledgmentEnabled) {
          this.props.setUserSettingState({ userSettings: settings })
        }
      }
    })()

    if (userSettings) {
      this.setState({
        acknowledgmentEnabled: userSettings.acknowledgmentEnabled
      })
    }

    this.setState({ contact })

    if (limitReached) {
      this.setState({ openLimitReachedDialog: true })
    }

    if (tourSteps) {
      this.setState({ tour: true })
    }

    let userData = session.get('userData')

    const secretKey = 'Zmef4H7P5ZQmLDeGFj-G-t1-gD0znUNn_KZgcJIP'
    const userIdentifier = userData.id.toString()
    const hash = CryptoJS.HmacSHA256(userIdentifier, secretKey).toString(CryptoJS.enc.Hex)

    if (nextProps.children !== this.props.children) {
      const selectedIndex = getSelectedMenuIndex(nextProps.location.pathname)
      const currentOpenKeys = getOpenKeys(this.props.location.pathname)
      const newOpenKeys = getOpenKeys(nextProps.location.pathname)

      const newState = { selectedIndex }
      if (currentOpenKeys.join(',') !== newOpenKeys.join(',')) {
        newState.openKeys = newOpenKeys
      }
      this.setState(newState)
    }

    // Deferred auto-trigger: if user navigates to dashboard and tour is pending
    if (
      this.state.dashboardTourPending &&
      nextProps.location.pathname === '/dashboard' &&
      this.props.location.pathname !== '/dashboard'
    ) {
      setTimeout(() => this.launchDashboardTour(), 800)
    }
  }

  handleSetNotificationList = (notifications, unreadCount) => {
    this.props.setNotification({ data: { notifications, unreadCount } })
  }

  showOptions = event => {
    this.setState({
      openOptions: !this.state.openOptions,
      anchorEl: event.currentTarget
    })
  }

  showTemplates = () => {
    mixpanel.track('inbox:view templates')

    this.setState({
      openModal: !this.state.openModal,
      openOptions: false
    })
  }

  toggleUserMenu = (event) => {
    event.preventDefault()
    this.setState({
      showUserMenu: !this.state.showUserMenu,
      anchorEl: event.currentTarget,
    })
  }

  toggleNotificationMenu = (event) => {
    event.preventDefault()
    this.setState({
      showNotificationMenu: !this.state.showNotificationMenu,
      notificationAnchorEl: event.currentTarget,
    })
  }

  // Closes the New Message dialog; the modal clears its own form state.
  handleClose = () => {
    this.setState({
      showUserMenu: false,
      openMessageModal: false,
      showNotificationMenu: false,
    })
  }

  logout = () => {
    mixpanel.track('auth:logout', { source: 'webapp' })

    const userData = session.get('userData')
    if (userData && userData.id) leaveRoom(userData.id)

    this.props.resetCompany()

    localStorage.clear()
    sessionStorage.clear()
    window.location.href = '/login'
  }

  isUserGhAdmin = () => {
    const userData = session.get('userData') || {}
    return (userData.role || '') === config.userRoles.ghAdmin
  }

  isUserCompanyAdmin = () => {
    const userData = session.get('userData') || {}
    return (userData.role || '') === config.userRoles.companyAdmin
  }

  handleToggle = () => {
    mixpanel.track('layout:toggle drawer')

    this.setState({ open: !this.state.open })
  }

  launchDashboardTour = () => {
    const userData = session.get('userData')

    this.setState({ dashboardTourPending: false })

    this.props.startTour({
      tourSteps: getDashboardSteps(),
      tourChangeSteps: () => {},
      tourCompleted: () => {
        if (userData?.id) {
          guideRes.markGettingStartedStepCompleted(userData.id, {
            tag: 'dashboard-tour',
          })
        }
      },
    })
  }

  handleMessage = async () => {
    // Without messaging.send the composer inside this modal is locked anyway —
    // go straight to the upsell instead of opening an unusable dialog.
    if (!getRuntimeFeatures().hasFeature('messaging.send')) {
      return openUpgradeModal('messaging.send')
    }

    mixpanel.track('layout:open new message modal')

    const [templates, seqRes] = await Promise.all([
      resources.getTemplates(),
      getSequenceTemplates(),
    ])
    const seqData = seqRes?.data || seqRes
    this.setState({
      openMessageModal: true,
      tmpls: templates.data,
      seqTmpls: seqData?.rows || [],
    })
  }

  closeLimitReachedDialog = () => {
    this.setState({ openLimitReachedDialog: false })
    this.props.sendLimitReached({ sendLimitReached: false })
  }

  handleMask = (value) => {
    if (value.length > 10) {
      return [
        '(',
        /[0-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]
    }
    return [
      '(',
      /[0-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ]
  }

  handleCheckBox = () => {
    getAllCompanies(this.state.isChecked).then((response) => {
      this.setState({
        isChecked: !this.state.isChecked,
        companyList: (response.data || []),
      })
    })
  }

  handleSelectCompany = value => {
    let companyData = {}
    const { companyId } = session.get('userData')
    const selectedCompanyId = value || companyId

    const filtered = this.state.companyList.filter(company => company.id === selectedCompanyId)
    companyData = filtered[0]

    this.props.setSelectedCompanyData({ selectedCompanyData: companyData })
    this.props.setSelectedCompany({ selectedCompany: value })
  }

  handleSelectSubCompany = async value => {
    const { subProfiles } = this.state
    const filteredProfile = subProfiles.filter(profile => profile.companyId === value)

    if (filteredProfile.length) {
      const userData = {
        ...filteredProfile[0],
        allProfiles: subProfiles,
        bots: filteredProfile[0].bots
      }

      session.set('token', filteredProfile[0].token)
      session.set('userBots', filteredProfile[0].bots)
      session.set('userData', userData)
      session.set('selectedSubCompany', filteredProfile[0])

      // Sub-profiles carry no `features` (getSubUsersWithTokens doesn't add it),
      // so fetch this profile's entitlements with its new token BEFORE the
      // reload — otherwise the session looks "unknown" and nothing stays locked.
      await refreshRuntimeFeatures()

      this.props.setSelectedSubCompany({ selectedSubCompany: filteredProfile[0] })
      // Entity-detail routes (e.g. /contacts/:id, /campaigns/:id) reference IDs
      // scoped to the previous brand's company — staying on them after a swap
      // 404s. Redirect to /inbox in that case; otherwise reload in place.
      const onEntityRoute = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(window.location.pathname)
      if (onEntityRoute) {
        window.location.assign('/inbox')
      } else {
        window.location.reload()
      }
    }
  }



  getMenuItems = () => {
    const menuItems = [
      {
        key: '/dashboard',
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        isAdmin: false,
      },
      {
        key: '/ai-assistants',
        icon: <ThunderboltOutlined />,
        label: 'AI Assistant',
        isAdmin: true,
        feature: 'ai-assistant',
      },
      {
        key: '/inbox',
        icon: <MessageOutlined />,
        label: 'Inbox',
        className: 'tour-inbox-start',
        isAdmin: false,
        feature: 'inbox',
      },
      {
        key: '/contacts',
        icon: <UserOutlined  onClick={(e) => { e.stopPropagation(); this.props.goTo('/contacts')(); }} />,
        label: (
          <span 
            onClick={(e) => {
              e.stopPropagation();
              this.props.goTo('/contacts')();
            }}
          >
            Contacts
          </span>
        ),
        className: `tour-contacts-start ${this.state.selectedIndex === '/contacts' ? 'ant-menu-item-selected' : ''}`,
        isAdmin: false,
        feature: 'contacts',
        children: [
          {
            key: '/groups',
            icon: <TeamOutlined />,
            label: 'Groups',
            isAdmin: false,
            feature: 'contacts',
          },
        ],
      },
      {
        key: '/templates',
        icon: <FileTextOutlined />,
        label: 'Templates',
        isAdmin: false,
        className: 'tour-templates-start',
        feature: 'templates.use',
      },
      {
        key: '/interview-invites',
        icon: <CalendarOutlined />,
        label: 'Interview Invites',
        isAdmin: false,
        className: 'tour-integrations-start',
        feature: 'interview-scheduling',
      },
      {
        key: '/campaign',
        icon: <SoundOutlined />,
        label: 'Broadcasts',
        isAdmin: false,
        className: 'tour-broadcast-start',
        feature: 'broadcasts',
      },
    ]

    if (this.state.defaultABT) {
      menuItems.push({
        key: '/apply-by-text',
        label: 'Apply by Text',
        icon: <QrcodeOutlined />,
        className: 'tour-abt-feat-start',
        isAdmin: false,
        feature: 'apply-by-text',
      })
    }

    if (!this.isUserGhAdmin() && this.isUserCompanyAdmin()) {
      menuItems.push({
        key: '/client-users',
        icon: <TeamOutlined />,
        label: 'Add Users',
        isAdmin: false,
      })
    }

    menuItems.push(
      {
        key: '/settings',
        icon: <SettingOutlined />,
        label: 'Settings',
        isAdmin: false,
      },
      {
        key: '/message-audit',
        icon: <UsergroupAddOutlined />,
        label: 'Admin',
        className: 'tour-contacts-start',
        isAdmin: true,
        children: [
          {
            key: '/message-audit',
            icon: <UnorderedListOutlined />,
            label: 'Message Audit',
            isAdmin: true,
          },
          {
            key: '/reporting',
            icon: <FileSearchOutlined />,
            label: 'Reporting',
            isAdmin: true,
          },
          {
            key: '/build-bot',
            icon: <BuildOutlined />,
            label: 'Build bot',
            isAdmin: true,
          },
          {
            key: '/vonage-numbers',
            icon: <PhoneOutlined />,
            label: 'Vonage Numbers',
            isAdmin: true,
          },

          {
            key: '/companies',
            icon: <TeamOutlined />,
            label: 'Companies',
            isAdmin: true,
          },
          {
            key: '/access-control',
            icon: <AppstoreOutlined />,
            label: 'Bundles',
            isAdmin: true,
          },
          {
            key: '/intent-dictionary',
            icon: <CommentOutlined />,
            label: 'Intent Dictionary',
            isAdmin: true,
          },
          {
            key: '/module-group',
            icon: <CommentOutlined />,
            label: 'Module Group',
            isAdmin: true,
          },
        ],
      },
      {
        key: '/queues',
        icon: <DashboardOutlined />,
        label: 'Health',
        isAdmin: true,
        children: [
          {
            key: '/queues',
            icon: <ClockCircleOutlined />,
            label: 'Scheduler',
            isAdmin: true,
          },
          {
            key: '/email-log',
            icon: <MailOutlined />,
            label: 'Email Log',
            isAdmin: true,
          },
          {
            key: '/ai-usage',
            icon: <ThunderboltOutlined />,
            label: 'AI Usage',
            isAdmin: true,
          },
          {
            key: '/sessions',
            icon: <TeamOutlined />,
            label: 'Sessions',
            isAdmin: true,
          },
        ],
      },
    )

    // Filter menu items based on isAdmin, then apply feature-lock treatment
    // (show-but-locked): a gated item the user lacks stays clickable with a lock
    // + tooltip, but its key is rerouted to `upsell:<feature>` so the Menu's
    // onClick opens the upgrade modal instead of navigating. Locks nothing when
    // the user has the feature / entitlements are unknown / GH Admin.
    const ghAdmin = this.isUserGhAdmin()
    const { hasFeature } = getRuntimeFeatures()
    const LABEL_BY_KEY = { '/contacts': 'Contacts' }

    const lockItem = (item) => {
      if (!item.feature || hasFeature(item.feature)) return item
      const text = typeof item.label === 'string' ? item.label : (LABEL_BY_KEY[item.key] || 'Locked')
      return {
        ...item,
        key: `upsell:${item.feature}`,
        children: undefined, // collapse a locked parent — its sub-items are gated too
        label: (
          <Tooltip title="Not included in your plan — click to learn more" placement="right">
            {/* Flex row, not text + trailing icon: the Menu ellipsizes the
                label, which clipped the lock off longer items (e.g. "Interview
                Invites" rendered as "Interview Invites..." with no lock). Let
                the text truncate and keep the lock pinned and unshrinkable. */}
            <span style={{
              opacity: 0.7, display: 'flex', alignItems: 'center', gap: 6, minWidth: 0,
            }}>
              <span style={{
                flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                {text}
              </span>
              <LockOutlined style={{ fontSize: 11, flexShrink: 0 }} />
            </span>
          </Tooltip>
        ),
      }
    }

    const filterMenuItems = (items) => {
      return items
        .filter(item => !item.isAdmin || ghAdmin)
        .map(item => {
          if (item.children) {
            return lockItem({
              ...item,
              children: filterMenuItems(item.children)
            })
          }
          return lockItem(item)
        })
    }

    return filterMenuItems(menuItems)
  }

  render() {
    const isGhAdmin = this.isUserGhAdmin()
    // Greys out the "Send New Message" CTA when messaging.send isn't in the plan.
    const canSendMessages = getRuntimeFeatures().hasFeature('messaging.send')
    let defLongNumLabel
    let defLongNum = this.state.defaultLongNum
    if (defLongNum) {
      defLongNum = formatUtil.forceFormat(defLongNum)
      defLongNumLabel = (
        <Tooltip title="Candidates can text you directly with this number.">
          <div className="user-default-number hide-on-smaller-screens" style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <PhoneOutlined style={{ fontSize: 14 }} />
            <span>{defLongNum}</span>
          </div>
        </Tooltip>
      )
    }

    const companyOptions = [
      { value: '', label: '' },
      ...this.state.companyList
        .slice()
        .sort((a, b) => {
          const aName = (a.name || '').toLowerCase().trim()
          const bName = (b.name || '').toLowerCase().trim()
          if (aName === bName) return 0
          if (aName < bName) return -1
          return 1
        })
        .map((company) => ({
          value: company.id,
          label: company.name
        }))
    ]

    const subProfileOptions = this.state.subProfiles.map((comp) => ({
      value: comp.companyId,
      label: comp.companyName
    }))

    const officeHrsBtn = {
      onClick: () => {
        mixpanel.track('office hours: click')
        this.props.goTo('/settings?tab=office-hours')()
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('focusOfficeHours'))
        }, 100)
      }
    }

    const userMenuItems = [
      {
        key: 'settings',
        label: 'Settings',
        icon: <SettingOutlined />,
        onClick: () => {
          this.setState({ showUserMenu: false })
          this.props.goTo('/settings?tab=profile')()
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('focusProfileTab'))
          }, 100)

        },
      },
      {
        key: 'logout',
        label: 'Log Out',
        icon: <LogoutOutlined />,
        onClick: () => {
          this.setState({ showUserMenu: false })
          this.logout()
        },
      },
    ]

    const user = session.get('userData') || {}

    const userMenuContent = (
      <div style={{ width: 220 }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px 12px' }}>
          <UserAvatar 
            name={user.name} 
            src={this.state.userAvatar || user.avatar_url || user.avatar || user.photo || '/assets/images/default-avatar.png'} 
            size={36} 
            showTooltip={false}
            userId={user.id}
          />
          <div style={{ marginLeft: 10, overflow: 'hidden' }}>
            <div style={{ fontWeight: 600, color: '#222', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{user.name}</div>
            <div style={{ fontSize: 12, color: '#888', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{user.companyName}</div>
          </div>
        </div>
        {
        /*commented out for now*/
        /* <Divider style={{ margin: '6px 0' }} />
        <div 
          style={{ 
            padding: '5px 12px', 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            cursor: 'default'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 8, fontSize: 16 }}>{this.context.isDarkMode ? '🌙' : '☀️'}</span>
            <span style={{ color: '#263238', fontSize: '14px' }}>Dark Mode</span>
          </div>
          <Switch 
            checked={this.context.isDarkMode} 
            onChange={this.context.toggleTheme} 
            size="small"
          />
        </div> */}
        <Divider style={{ margin: '6px 0' }} />
        <Menu items={userMenuItems} style={{ border: 'none' }} selectable={false} />
      </div>
    )

    const notificationContent = (
      <div style={{ width: 360 }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          padding: '4px 16px',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <span style={{ fontWeight: 600, fontSize: 14, color: '#3f3f3f' }}>Notifications</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <a
              style={{ cursor: 'pointer', fontSize: 12, color: '#888' }}
              onClick={async (event) => {
                event.preventDefault()
                const unread = _.filter(this.props.latestNotifications, {
                  is_read: false,
                })

                if (!unread.length) {
                  return
                }

                await readNotifications({ is_read: [] })
                // Mark all notifications as read in the state instead of refetching
                const updatedNotifications = this.props.latestNotifications.map(n => ({
                  ...n,
                  is_read: true
                }))
                this.handleSetNotificationList(updatedNotifications, 0)
              }}
            >
              Mark all as read
            </a>
          </div>
        </div>
        <NotificationListAntd
          count={this.notificationCount}
          notificationList={this.props.latestNotifications}
          handleSetNotificationList={this.handleSetNotificationList}
        />
      </div>
    )

    const numbersContent = (
      <div style={{ width: 250, padding: '5' }}>
        {!isGhAdmin && this.state.defaultABT && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: 10, color: '#888', marginBottom: 4, textTransform: 'uppercase' }}>
              Apply By Text Number
            </div>
            <div style={{ fontSize: 14, fontWeight: 500 ,display:'flex',gap:8,alignItems:'center' }}>
              <QrcodeOutlined
                className="qr-code-icon" 
                style={{ fontSize: '18px', color: '#666', cursor: 'pointer', marginRight: '4px' }} 
                onClick={() => this.props.history.push('/apply-by-text')}
              />
              {formatUtil.forceFormat(this.state.defaultABT)}</div>
            <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>
              Add "Now Hiring! Text "{this.state.keyword}" to this number on your career list.
            </div>
          </div>
        )}
        {this.state.defaultLongNum && (
          <div>
            <div style={{ fontWeight: 'bold', fontSize: 10, color: '#888', marginBottom: 4, textTransform: 'uppercase' }}>Direct Text Number</div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{formatUtil.forceFormat(this.state.defaultLongNum)}</div>
            <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>
              Candidates can text you directly with this number.
            </div>
          </div>
        )}
      </div>
    )

    return (
        <MuiThemeProvider muiTheme={theme}>
        <Layout className="app-container" style={{ minHeight: '100vh' }}>
        <Steps
          enabled={this.state.tour}
          steps={this.props.tourSteps}
          ref={(steps) => (this.steps = steps)}
          initialStep={0}
          onExit={(stepIndex) => {
            this.props.startTour({ tourSteps: [] })
            this.setState({ tour: false })
          }}
          onComplete={this.props.tourCompleted}
          onBeforeChange={this.props.tourChangeSteps}
          onChange={(step, _) => {
            setTimeout(this.onTourStepChange(step, _), 2000, true)
          }}
          options={{
            doneLabel: 'Finish',
            nextLabel: 'Next',
            prevLabel: 'Back',
            exitOnOverlayClick: false,
            scrollToElement: true,
            showStepNumbers: false,
            showBullets: false,
          }}
        />

        <Header
          style={{
            backgroundColor: '#34464f',
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 54,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: '1 1 auto' }}>
            <Button
              type="text"
              icon={this.state.open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
              onClick={this.handleToggle}
              style={{ color: '#fff', fontSize: 18, flex: '0 0 auto' }}
            />
            <div className="app-bar-logo-container" style={{ marginLeft: 0 }}>
              <img src="/assets/images/logo.png" alt="logo" style={{ height: 40 }} />
              {!isGhAdmin && this.state.defaultABT && (
                <>
                  {this.state.qrImage.length > 0 && (
                    <div
                      onClick={() => this.props.history.push('/apply-by-text')}
                      className="qr-icon-wrapper"
                      style={{ marginLeft: '16px', cursor: 'pointer'}}
                    >
                      <QrcodeOutlined className="qr-code-icon" style={{ fontSize: '24px', color: '#fff' }} />
                    </div>
                  )}
                  <Popover content={numbersContent} title={<div style={{ padding:'0px 10px' }}>Your phone numbers</div>} trigger="click" placement="bottomLeft">
                    <Tag
                      className="phone-numbers-tag"
                      style={{
                        cursor: 'pointer',
                        margin: 0,
                        padding: '2px 8px',
                        fontSize: '12px',
                        alignItems: 'center',
                        height: '24px',
                        borderRadius: '12px',
                        backgroundColor: '#34464f',
                        color: '#fff',
                        borderColor: 'transparent'
                      }}
                    >
                      <PhoneOutlined style={{ fontSize: 14, marginRight: 4 }} />
                      Your Phone Numbers
                    </Tag>
                  </Popover>
                  <div className="abt-text-container" style={{ marginLeft: 5, color: '#fff' }}>
                    <div>
                      Your Apply By Text Number is:{' '}
                      <span>{formatUtil.forceFormat(this.state.defaultABT)}</span>
                    </div>
                    <div className="abt-text-sub" style={{ fontSize: 11 }}>
                      Add "Now Hiring! Text "{this.state.keyword}" to{' '}
                      <span>{formatUtil.forceFormat(this.state.defaultABT)}</span>" on
                      your career list and all job postings.
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: '0 1 auto', justifyContent: 'flex-end' }}>
            {/* Office Hours auto-replies to inbound 1-1 texts, so it is dead
                without messaging.send — show the badge locked rather than an
                ON/OFF state the user cannot act on. */}
            <Tooltip title={canSendMessages ? '' : 'Not included in your plan — click to learn more'}>
              <Tag
                color={this.state.acknowledgmentEnabled && canSendMessages ? 'success' : 'default'}
                onClick={canSendMessages ? officeHrsBtn.onClick : () => openUpgradeModal('messaging.send')}
                style={{
                  cursor: 'pointer',
                  margin: 0,
                  padding: '2px 8px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  height: '24px',
                  borderRadius: '12px',
                  backgroundColor: this.state.acknowledgmentEnabled && canSendMessages ? '#4caf50' : '#BDBDBD',
                  color: '#fff',
                  borderColor: 'transparent',
                  marginRight: 20,
                  opacity: canSendMessages ? 1 : 0.7
                }}
              >
                {canSendMessages
                  ? `Office Hours - ${this.state.acknowledgmentEnabled ? 'ON' : 'OFF'}`
                  : <><LockOutlined style={{ marginRight: 4, fontSize: 11 }} />Office Hours</>}
              </Tag>
            </Tooltip>

            {defLongNumLabel}

            {isGhAdmin && (
              <div className="header-admin-checkbox">
                <Checkbox
                  checked={this.state.isChecked}
                  onChange={() => this.handleCheckBox()}
                  style={{ color: '#fff' }}
                >
                  <span style={{ color: '#fff' }}>Include Inactive</span>
                </Checkbox>
              </div>
            )}

            {isGhAdmin && (
              <Select
                placeholder="Company"
                value={this.props.selectedCompany || undefined}
                onChange={this.handleSelectCompany}
                style={{ width: 200, flex: '0 1 auto', minWidth: 100 }}
                options={companyOptions}
                allowClear
                showSearch
                optionFilterProp="label"
              />
            )}

            {this.state.subProfiles.length > 0 && (
              <Select
                placeholder="Sub-company"
                value={
                  this.props.selectedSubCompany
                    ? this.props.selectedSubCompany.companyId
                    : undefined
                }
                onChange={this.handleSelectSubCompany}
                style={{ width: 'auto', flex: '0 1 auto', minWidth: 150, maxWidth: 320 }}
                popupMatchSelectWidth={false}
                options={subProfileOptions}
              />
            )}

            <Popover
              content={notificationContent}
              trigger="click"
              placement="bottomRight"
              open={this.state.showNotificationMenu}
              onOpenChange={(visible) => this.setState({ showNotificationMenu: visible })}
            >
              <div className="notification-wrapper" style={{ cursor: 'pointer', paddingTop: 4 }}>
                {this.props.unreadCount > 0 ? (
                  <Badge count={this.props.unreadCount} size="small" >
                    <BellOutlined style={{ fontSize: 18, fontWeight: 600, color: '#4caf50' }} />
                  </Badge>
                ) : (
                  <BellOutlined style={{ fontSize: 18, fontWeight:600, color: '#4caf50' }} />
                )}
              </div>
            </Popover>


            <Popover
              content={userMenuContent}
              trigger="click"
              placement="bottomRight"
              open={this.state.showUserMenu}
              onOpenChange={(visible) => this.setState({ showUserMenu: visible })}
            >
              <div style={{ padding: '0 8px', display: 'flex', alignItems: 'center' }}>
                <UserAvatar
                  name={session.get('userData') ? (session.get('userData').name || 'User') : 'User'}
                  src={this.state.userAvatar || (session.get('userData') || {}).avatar_url || (session.get('userData') || {}).avatar || (session.get('userData') || {}).photo || '/assets/images/default-avatar.png'}
                  size={28}
                  userId={(session.get('userData') || {}).id}
                  onRefresh={this.handleAvatarRefresh}
                  style={{ cursor: 'pointer', border: '2px solid rgba(255,255,255,0.12)' }}
                  showTooltip={false}
                />
              </div>
            </Popover>

            
          </div>
        </Header>

        <Layout>
          <Sider
            collapsible
            collapsed={!this.state.open}
            onCollapse={(collapsed) => this.setState({ open: !collapsed })}
            trigger={null}
            width={200}
            collapsedWidth={50}
            style={{
              backgroundColor: '#f0f0f0',
              height: 'calc(100vh - 54px)',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <div style={{ padding: this.state.open ? '12px 20px' : '12px 4px', flexShrink: 0 }}>
              <Button
                type="primary"
                className="tour-send-new-message"
                onClick={this.handleMessage}
                style={{
                  width: '100%',
                  backgroundColor: canSendMessages ? '#4caf50' : '#bfbfbf',
                  borderColor: canSendMessages ? '#4caf50' : '#bfbfbf',
                  fontSize: this.state.open ? 12 : 10,
                }}
              >
                {this.state.open
                  ? <>{!canSendMessages && <LockOutlined style={{ marginRight: 6 }} />}Send New Message</>
                  : <MessageOutlined style={{ fontSize: 16, color: '#fff' }} />}
              </Button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
              <Menu
              mode="inline"
              selectedKeys={[this.state.selectedIndex]}
              openKeys={this.state.openKeys}
              onOpenChange={(openKeys) => this.setState({ openKeys })}
              style={{ backgroundColor: 'transparent', borderRight: 0, paddingBottom: 10 }}
              items={this.getMenuItems()}
              onClick={({ key }) => {
                if (key && key.startsWith('upsell:')) {
                  openUpgradeModal(key.slice('upsell:'.length))
                  return
                }
                if (key && !key.startsWith('abt')) {
                  this.props.goTo(key)()
                }
              }}
            />
            </div>
            <div style={{ flexShrink: 0, fontWeight:500, width: '100%', padding: this.state.open ? '8px 16px' : '8px 4px', fontSize: 12, color: '#888', textAlign: 'center', backgroundColor: '#f0f0f0' }}>
               <Divider style={{ margin: 0, marginBottom: 8 }} />
           
              {config.version}
            </div>
          </Sider>

          <Content
            className={`app-content ${this.state.open ? 'expanded' : ''}`}
            style={{
              padding: 0,
              overflow: 'hidden',
              backgroundColor: '#fff',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div 
              ref={this.scrollContainerRef} 
              className="global-scroll-wrapper" 
              style={{ overflow: 'auto', flex: 1 }}
            >
              <div style={{ minWidth: 1080, minHeight: '100%' }}>
                {this.props.children}
              </div>
            </div>
            <MinimapScroll containerRef={this.scrollContainerRef} />
          </Content>
        </Layout>

        {/* QR Dialog */}
        <Modal
          open={this.state.QRDialogVisible}
          onCancel={() => this.setState({ QRDialogVisible: false })}
          footer={[
            <Button key="close" onClick={() => this.setState({ QRDialogVisible: false })}>
              Close
            </Button>
          ]}
        >
          <Row>
            <Col xs={12} className="text-center" style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={this.state.qrImage} height="400" width="400" />
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12} className="text-center" style={{ fontWeight: 'bold', textAlign: 'center' }}>
              Your Apply By Text Number is:{' '}
              <span>{formatUtil.forceFormat(this.state.defaultABT)}</span>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="text-center" style={{ textAlign: 'center' }}>
              Add "Now Hiring! Text "{this.state.keyword}" to{' '}
              <span>{formatUtil.forceFormat(this.state.defaultABT)}</span>" on
              your career list and all job postings.
            </Col>
          </Row>
        </Modal>

        {/* Limit Reached Dialog */}
        <Modal
          open={this.state.openLimitReachedDialog}
          onCancel={this.closeLimitReachedDialog}
          footer={[
            <Button key="close" onClick={this.closeLimitReachedDialog}>
              Close
            </Button>
          ]}
          width={400}
        >
          <div style={{ textAlign: 'center' }}>
            <h4>You have reached the limit of your Free Trial.</h4>
            <h4>You can purchase a monthly account here.</h4>
          </div>
        </Modal>

        {/* No Calendar Integration Dialog */}
        <Modal
          title="Interview Schedule Integration"
          open={this.state.showNoCalendarDialog}
          onCancel={() => this.setState({ showNoCalendarDialog: false })}
          footer={[
            <Button
              key="close"
              onClick={() =>
                this.setState({
                  showNoCalendarDialog: false,
                  openMessageModal: true,
                })
              }
            >
              Close
            </Button>
          ]}
        >
          <h4>
            You need to integrate your calendar before being able to use this feature.
          </h4>
          <h4>
            Click
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                this.setState({ showNoCalendarDialog: false })
                this.props.history.replace({
                  pathname: '/interview-invites/integrations',
                })
              }}
            >
              {' '}here{' '}
            </a>
            to process integration.
          </h4>
        </Modal>

        {/* New Message Dialog */}
        <NewMessageModal
          open={this.state.openMessageModal}
          onClose={this.handleClose}
          templates={this.state.tmpls}
          sequenceTemplates={this.state.seqTmpls}
          onCalendarSetup={() => {
            this.handleClose()
            this.props.history.push('/interview-invites?tab=integrations')
          }}
          userHasCalendar={async () => {
            // Fail soft: a failing calendar lookup must not surface as an
            // unhandled rejection (the API rejects with a plain payload object,
            // which the dev overlay renders as "[object Object]").
            try {
              const data = await checkUserGroupDefault('calendar')
              return (data && data.data) || []
            } catch (err) {
              console.error('Failed to check user calendar:', err)
              return []
            }
          }}
          sendCalendarInvite={(payload) => resources.sendInterviewScheduling(payload)}
        />

      </Layout>
    </MuiThemeProvider>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    notification: { unreadCount, latestNotifications },
    inbox: { sendLimitReached: limitReached, contact },
    company: { selectedCompany, selectedSubCompany },
    user: { userSettings },
    tour: {
      tourSteps,
      tourChangeSteps,
      tourCompleted,
    },
  } = state
  return {
    limitReached,
    contact,
    selectedCompany,
    selectedSubCompany,
    tourSteps,
    tourChangeSteps,
    tourCompleted,
    unreadCount,
    latestNotifications,
    userSettings
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
    goTo(url, params = {}) {
      return () => {
        mixpanel.track(`layout:change route`, {
          url,
          parameters: params,
        })
        return dispatch(push(url, params))
      }
    },
    sendLimitReached(data) {
      dispatch(sendLimitReached(data))
    },
    setSelectedCompany(data) {
      dispatch(setSelectedCompany(data))
    },
    setSelectedCompanyData(data) {
      dispatch(setSelectedCompanyData(data))
    },
    setSelectedSubCompany(data) {
      dispatch(setSelectedSubCompany(data))
    },
    resetCompany() {
      dispatch(resetCompany())
    },
    startTour(data) {
      dispatch(startTour(data))
    },
    setNotification(data) {
      dispatch(setNotification(data))
    },
    setUserSettingState(data) {
      dispatch(setUserSettingState(data))
    },
  }
}

const ConnectedLayout = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(LayoutComponent))

export default ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <ConnectedLayout className="yeeeeh">
          <Component {...matchProps} />
        </ConnectedLayout>
      )}
    />
  )
}
